import type { ListedLot } from '@features/buyer-line-items-pagination/types/listed-lot';

const hasSno = (sno: unknown): sno is number => typeof sno === 'number';

export const compareShellLots = (a: ListedLot, b: ListedLot): number => {
  if (hasSno(a.sno) && hasSno(b.sno) && a.sno !== b.sno) return a.sno - b.sno;
  if (hasSno(a.sno) !== hasSno(b.sno)) return hasSno(a.sno) ? -1 : 1;

  return Number(a.id) - Number(b.id);
};
